import React from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import { EmojiTitleSelectionPlaceholder } from '../src/emoji-title/EmojiTitleSelectionPlaceholder.tsx';

import type { EmojiTitleStateContainer } from './emojiTitleStateContainer.ts';

export const EmojiTitleSelection: LoadableType<
	Omit<
		{
			emojiTitleState: EmojiTitleStateContainer;
			onUpdateStartEmoji?: () => void;
			onUpdateEndEmoji?: () => void;
			isTitleDisabled: boolean;
			contentId: string;
			isTitleCenterAligned?: boolean;
			linkCreation?: boolean;
			hasCoverPicture?: boolean;
			isReadOnly?: boolean;
			contentType?: string;
			updateContentTree?: () => void;
			hasInitialEmoji?: boolean;
			pageTitleContent?: string;
			isAutoPageEmojiEligible?: boolean;
			isUnpublishedDraft?: boolean;
			isEditorEmpty?: boolean;
			emojiTitleDiscovered?: boolean;
			isSmartCreate?: boolean;
		},
		'emojiTitleState'
	>
> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-srcemoji-titleEmojiTitleSelection" */ '../src/emoji-title/EmojiTitleSelection.tsx'
			)
		).EmojiTitleSelection,
	loading: (props) => <EmojiTitleSelectionPlaceholder {...props} />,
});
